import React, { useState, useEffect } from 'react';
import { Spin, message, Table } from 'antd';
import { getcomponenteAmbiental, eventosdesastres } from '../../../services/perfiles/conponentesServices';
import './tablaG.css';

const ResiduosC = ({ municipioId, onPageChange }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [eventosData, setEventosData] = useState([]);
    const [municipioNombre, setMunicipioNombre] = useState('');

    useEffect(() => {
        if (municipioId) {
                   fetchData();
        fetcheventosdesastres(); 
        }

    }, [municipioId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await getcomponenteAmbiental(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    setData(fetchedData);
                    setMunicipioNombre(response.data[0]?.municipio || 'Desconocido');
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const fetcheventosdesastres = async () => {
        setLoading(true);
        try {
            const response = await eventosdesastres(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    setEventosData(fetchedData);
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading disaster event data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    // Preparar los datos para la nueva estructura de la tabla
    const formatEventData = (data) => {
        if (data.length === 0) return [];
        
        const formattedData = [
            { key: 'frec_avenidas_torrenciales', field: 'Avenidas Torrenciales (frecuencia)', value: data[0].frec_avenidas_torrenciales, percentage: data[0].porc_avenidas_torrenciales },
            { key: 'porc_avenidas_torrenciales', field: 'Avenidas Torrenciales (%)', value: '', percentage: data[0].porc_avenidas_torrenciales },
            { key: 'frec_movimientos', field: 'Movimientos en Masa (frecuencia)', value: data[0].frec_movimientos, percentage: data[0].porc_movimientos },
            { key: 'porc_movimientos', field: 'Movimientos en Masa (%)', value: '', percentage: data[0].porc_movimientos },
            { key: 'frec_erupciones', field: 'Erupciones Volcánicas (frecuencia)', value: data[0].frec_erupciones, percentage: data[0].porc_erupciones },
            { key: 'porc_erupciones', field: 'Erupciones Volcánicas (%)', value: '', percentage: data[0].porc_erupciones },
            { key: 'frec_incendios', field: 'Incendios Forestales (frecuencia)', value: data[0].frec_incendios, percentage: data[0].porc_incendios },
            { key: 'porc_incendios', field: 'Incendios Forestales (%)', value: '', percentage: data[0].porc_incendios },
            { key: 'frec_inundaciones', field: 'Inundaciones (frecuencia)', value: data[0].frec_inundaciones, percentage: data[0].porc_inundaciones },
            { key: 'porc_inundaciones', field: 'Inundaciones (%)', value: '', percentage: data[0].porc_inundaciones },
            { key: 'frec_sequias', field: 'Sequías (frecuencia)', value: data[0].frec_sequias, percentage: data[0].porc_sequias },
            { key: 'porc_sequias', field: 'Sequías (%)', value: '', percentage: data[0].porc_sequias },
            { key: 'frec_sismos', field: 'Sismos (frecuencia)', value: data[0].frec_sismos, percentage: data[0].porc_sismos },
            { key: 'porc_sismos', field: 'Sismos (%)', value: '', percentage: data[0].porc_sismos },
            { key: 'frec_total_acomulado', field: 'Total Acomulado (frecuencia)', value: data[0].frec_total_acomulado, percentage: data[0].porc_total_acomulado },
            { key: 'porc_total_acomulado', field: 'Total Acomulado (%)', value: '', percentage: data[0].porc_total_acomulado },
        ];

        return formattedData;
    };

    // Definir las columnas para la tabla de eventos de desastres
    const disasterEventColumns = [
        { title: 'Campo', dataIndex: 'field', key: 'field', className: 'filaP' },
        { title: 'Valor', dataIndex: 'value', key: 'value', className: 'filaP' },
        { title: 'Porcentaje', dataIndex: 'percentage', key: 'percentage', className: 'filaP' },
    ];

    return (
        <div className="page-content">
            {loading ? (
                <Spin size="large" />
            ) : data.length > 0 ? (
                data.map(item => (
                    <div key={item.idinformacion}>
                        <div className="section">
                            <h3>Manejo de Residuos</h3>
                            <div style={{ columnCount: 2, columnGap: '30px' }} dangerouslySetInnerHTML={{ __html: item.manejo_residual }} />
                            <p>{item.fuente_m}</p>
                        </div>
                    </div>
                ))
            ) : (
                <p>No hay datos disponibles para este municipio.</p>
            )}

            <div className="section">
                <h3>Eventos de Desastres</h3>
                <Table
                    columns={disasterEventColumns}
                    dataSource={formatEventData(eventosData)}
                    rowKey="key"
                    pagination={{ pageSize: 5 }}
                    footer={() => (
                        <div>
                            <p>{`Fuente: ${eventosData[0]?.fuente || 'Desconocido'}`}</p>
                        </div>
                    )}
                />
            </div>
        </div>
    );
};

export default ResiduosC;
